import React, { useEffect } from 'react'
import { useState } from 'react';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import { formatDate, formatDateYYYYMMDD, formatDateTxt } from "../../utils/formatDate.js";
import CardSlider6 from "../../components/cardSlide/Slick6"
import { Link } from 'react-router-dom';

function PreviewNewsEvent({ type,save,close,cover,title,desc,datePublish,desc2,desc3,imgCol2,imgCol3 }) {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );

    const [dataId, setDataId] = useState(null);

    const [inputForm, setInputForm] = useState({
        inp1: "",
        inp2: "",
        inp3: ""
    });
    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }
    useEffect(()=>{
        let updatedInfoListDatas = []
        updatedInfoListDatas.push({
            images: cover??'',
            txtDesc: desc,
        })
        updatedInfoListDatas.push({
            images: imgCol2?.length>0?imgCol2.map((imageSrc, index) => {
                return imageSrc.src
            }):[],
            txtDesc: desc2,
        })
        updatedInfoListDatas.push({
            images: imgCol3?.length>0?imgCol3.map((imageSrc, index) => {
                return imageSrc.src
            }):[],
            txtDesc: desc3,
        })
        setListDatasSlider1(updatedInfoListDatas);
    },[cover,desc,imgCol2,desc2,imgCol3,desc3])

    const [listDatasSlider1, setListDatasSlider1] = useState([
        {
            images: [
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
            ],
            txtDesc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to",
        },
        {
            images: [
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
            ],
            txtDesc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to",
        },
        {
            images: [
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
                '/assets/images/retail/img1.png',
            ],
            txtDesc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        }
    ]);


    useEffect(() => {
        let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                setDataId(id);
            }
    }, [type])

  return (
    <div className="container-fluid w-100">
        <style>
                {`
                    .image-gallery-item img {
                        width: 800px !important;
                        height: 450px !important;
                    }
                `}
        </style>
        {/* <h1>{ type === 'news' ? 'NEWS' : 'EVENT'}</h1> */}
        <Row className='mt-4'>
                <Col xs={12}>
                    <div className='px-10'>
                        <img src={cover} alt='' className='im-slip'/>
                    </div>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col xs={12}>
                    <div className='px-20'>
                        <font className="font-size04 colorBlack01 fontBold">{title}</font>
                    </div>
                </Col>
            </Row>
            <Row className='my-3'>
                <Col xs={12}>
                    <div className='px-20'>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.883 25.3391C6.07297 25.3391 0.542969 19.7991 0.542969 12.9991C0.542969 6.19915 6.08296 0.65918 12.883 0.65918C19.683 0.65918 25.223 6.19915 25.223 12.9991C25.223 19.7991 19.683 25.3391 12.883 25.3391ZM12.883 2.76917C7.24297 2.76917 2.65295 7.35915 2.65295 12.9991C2.65295 18.6391 7.24297 23.2291 12.883 23.2291C18.523 23.2291 23.103 18.6391 23.103 12.9991C23.103 7.35915 18.513 2.76917 12.883 2.76917Z" fill="black"/>
                            <path d="M12.8803 14.0498C12.3003 14.0498 11.8203 13.5797 11.8203 12.9897V5.35974C11.8203 4.77974 12.2903 4.2998 12.8803 4.2998C13.4703 4.2998 13.9403 4.76974 13.9403 5.35974V12.9897C13.9403 13.5697 13.4703 14.0498 12.8803 14.0498Z" fill="black"/>
                            <path d="M12.8803 3.45935C12.3003 3.45935 11.8203 2.98941 11.8203 2.39941V1.70935C11.8203 1.12935 12.2903 0.649414 12.8803 0.649414C13.4703 0.649414 13.9403 1.11935 13.9403 1.70935V2.39941C13.9403 2.97941 13.4703 3.45935 12.8803 3.45935Z" fill="black"/>
                            <path d="M12.8803 25.3392C12.3003 25.3392 11.8203 24.8693 11.8203 24.2793V23.5892C11.8203 23.0092 12.2903 22.5293 12.8803 22.5293C13.4703 22.5293 13.9403 22.9992 13.9403 23.5892V24.2793C13.9403 24.8593 13.4703 25.3392 12.8803 25.3392Z" fill="black"/>
                            <path d="M24.1602 14.0497H23.4702C22.8902 14.0497 22.4102 13.5796 22.4102 12.9896C22.4102 12.3996 22.8802 11.9297 23.4702 11.9297H24.1602C24.7402 11.9297 25.2202 12.3996 25.2202 12.9896C25.2202 13.5796 24.7502 14.0497 24.1602 14.0497Z" fill="black"/>
                            <path d="M2.28125 14.0497H1.59125C1.01125 14.0497 0.53125 13.5796 0.53125 12.9896C0.53125 12.3996 1.00125 11.9297 1.59125 11.9297H2.28125C2.86125 11.9297 3.34125 12.3996 3.34125 12.9896C3.34125 13.5796 2.87125 14.0497 2.28125 14.0497Z" fill="black"/>
                            <path d="M17.694 5.1887C17.604 5.1887 17.514 5.16864 17.434 5.11864C17.184 4.96864 17.094 4.64867 17.234 4.39867L17.544 3.85863C17.694 3.60863 18.014 3.51869 18.264 3.66869C18.514 3.81869 18.604 4.13866 18.454 4.38866L18.144 4.9287C18.044 5.0987 17.874 5.19859 17.684 5.19859L17.694 5.1887Z" fill="black"/>
                            <path d="M7.76434 22.399C7.67434 22.399 7.58433 22.3789 7.50433 22.3289C7.25433 22.1789 7.16432 21.8589 7.30432 21.6089L7.61431 21.069C7.76431 20.809 8.08431 20.7289 8.33431 20.8689C8.58431 21.0189 8.67432 21.3389 8.52432 21.5889L8.21432 22.1289C8.11432 22.2989 7.94433 22.399 7.75433 22.399H7.76434Z" fill="black"/>
                            <path d="M21.7535 18.6483C21.6635 18.6483 21.5735 18.6282 21.4935 18.5782L20.9535 18.2683C20.7035 18.1183 20.6135 17.7983 20.7535 17.5483C20.9035 17.2983 21.2235 17.2082 21.4735 17.3482L22.0135 17.6583C22.2635 17.8083 22.3535 18.1283 22.2035 18.3783C22.1035 18.5483 21.9335 18.6483 21.7435 18.6483H21.7535Z" fill="black"/>
                            <path d="M4.55432 8.70875C4.46432 8.70875 4.37434 8.6888 4.29434 8.6388L3.75433 8.32874C3.50433 8.17874 3.41432 7.85877 3.55432 7.60877C3.69432 7.35877 4.02432 7.26882 4.27432 7.40882L4.81433 7.71876C5.06433 7.86876 5.15434 8.18885 5.01434 8.43885C4.91434 8.60885 4.74432 8.70875 4.55432 8.70875Z" fill="black"/>
                            <path d="M8.07256 5.18895C7.89256 5.18895 7.71254 5.08893 7.61254 4.91893L7.30254 4.37889C7.16254 4.12889 7.24255 3.79892 7.50255 3.65892C7.75255 3.50892 8.07255 3.59886 8.22255 3.84886L8.53255 4.3889C8.68255 4.6389 8.59255 4.96887 8.34255 5.10887C8.26255 5.15887 8.17254 5.17894 8.08254 5.17894L8.07256 5.18895Z" fill="black"/>
                            <path d="M18.011 22.3986C17.831 22.3986 17.6509 22.3086 17.5509 22.1386L17.2409 21.5986C17.0909 21.3486 17.1809 21.0186 17.4309 20.8786C17.6809 20.7286 18.0009 20.8187 18.1509 21.0687L18.4609 21.6086C18.6109 21.8586 18.5209 22.1886 18.2709 22.3286C18.1909 22.3786 18.0909 22.3986 18.0009 22.3986H18.011Z" fill="black"/>
                            <path d="M4.01256 18.6494C3.83256 18.6494 3.65254 18.5494 3.55254 18.3794C3.41254 18.1294 3.49255 17.7995 3.75255 17.6595L4.29256 17.3494C4.54256 17.2094 4.86256 17.2895 5.01256 17.5495C5.15256 17.7995 5.07255 18.1294 4.81255 18.2694L4.27254 18.5794C4.19254 18.6294 4.10256 18.6494 4.01256 18.6494Z" fill="black"/>
                            <path d="M21.2244 8.7086C21.0444 8.7086 20.8644 8.61859 20.7644 8.44859C20.6144 8.19859 20.7044 7.86862 20.9544 7.72862L21.4944 7.41869C21.7444 7.26869 22.0744 7.35863 22.2144 7.60863C22.3644 7.85863 22.2744 8.1886 22.0244 8.3286L21.4844 8.63866C21.4044 8.68866 21.3144 8.7086 21.2244 8.7086Z" fill="black"/>
                            <path d="M9.6825 17.249C9.4125 17.249 9.1425 17.1491 8.9325 16.9391C8.5225 16.5291 8.5225 15.8591 8.9325 15.4391L12.0025 12.369C12.4125 11.959 13.0825 11.959 13.5025 12.369C13.9125 12.779 13.9125 13.449 13.5025 13.869L10.4325 16.9391C10.2225 17.1491 9.9525 17.249 9.6825 17.249Z" fill="black"/>
                        </svg>
                        <font className="font-size08 colorGray fontLight ms-3">
                            {/* {formatDateTxt(dateEff)} */}
                            Publish Date: {`${datePublish}`}
                        </font>
                    </div>
                </Col>
            </Row>
            <Row className='mt-1 mb-5'>
                <Col xs={12}>
                    <div className='px-20'>
                        <font className="font-size08 colorBlack01 fontLight"><div dangerouslySetInnerHTML={{ __html: desc}}></div></font>
                    </div>
                </Col>
            </Row>
            <div className='w-100 d-flex justify-content-center align-items-center'>
                <Row className='w-90'>
                    <Col xs={12}>
                        <CardSlider6
                            data={listDatasSlider1}
                        />
                    </Col>
                </Row>
            </div>
            <Row className='mt-3'>
                <Col xs={12}>
                    <div className="d-flex justify-content-end align-items-center w-100">
                                    <div className="font-size02 fontBold colorBlack text-decoration-none">
                                        SHARE
                                    </div>
                                    &nbsp;&nbsp;
                                    <div>
                                    <svg width={150} height={30} viewBox="0 0 150 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_2013_5039)">
                                            <Link className='cursor-none'>
                                                <path d="M14.8394 29.8267C23.035 29.8267 29.6789 23.1498 29.6789 14.9134C29.6789 6.67694 23.035 0 14.8394 0C6.64384 0 0 6.67694 0 14.9134C0 23.1498 6.64384 29.8267 14.8394 29.8267Z" fill="#0767FF" />
                                                <path d="M16.1014 11.2636V13.1751H18.5531L18.149 15.8069H16.1014V22.0939H13.2941V15.8069H10.9609V13.1751H13.2941V10.5271C13.2941 8.98381 14.5388 7.73291 16.0745 7.73291H18.7093V10.1102H17.2437C16.6079 10.1102 16.096 10.63 16.096 11.2636H16.1014Z" fill="white" />
                                            </Link>
                                            <Link className='cursor-none'>
                                                <path d="M54.941 29.8267C63.1366 29.8267 69.7804 23.1498 69.7804 14.9134C69.7804 6.67694 63.1366 0 54.941 0C46.7454 0 40.1016 6.67694 40.1016 14.9134C40.1016 23.1498 46.7454 29.8267 54.941 29.8267Z" fill="black" />
                                                <path d="M56.1015 14.0955L60.6493 9.19482H59.5393L55.6112 13.4295L52.4644 9.19482H48.9674L53.6714 15.5197L48.9297 20.6316H50.0451L54.1671 16.1858L57.4702 20.6316H60.9672L56.1069 14.0901L56.1015 14.0955ZM54.7221 15.5793L54.2264 14.9132L50.5839 10.0125H52.0495L55.04 14.036L55.5358 14.702L59.3345 19.814H57.8689L54.7221 15.5793Z" fill="white" />
                                            </Link>
                                            <Link className='cursor-none'>
                                                <path d="M95.0582 30.0001C103.254 30.0001 109.898 23.3231 109.898 15.0867C109.898 6.85028 103.254 0.17334 95.0582 0.17334C86.8626 0.17334 80.2188 6.85028 80.2188 15.0867C80.2188 23.3231 86.8626 30.0001 95.0582 30.0001Z" fill="#1ABA20" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M95.0547 8.13916C99.0905 8.13916 102.383 10.8305 102.383 14.1013C102.383 15.8558 101.488 17.3774 100.017 18.4659C96.9514 21.1139 95.2487 21.8558 95.2487 21.8558C94.5913 22.2078 94.4727 22.0128 94.5482 21.3901C94.6236 21.0002 94.7044 20.4911 94.7044 20.4911C94.7799 20.1392 94.3919 20.0633 94.241 20.0254H94.1656C90.5177 19.6735 87.7266 17.1392 87.7266 14.1013C87.7266 10.8251 91.0242 8.13916 95.0547 8.13916Z" fill="white" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M90.2031 15.8177H92.4932V15.195H90.9036V12.5037H90.2031V15.8177ZM92.8811 15.8177H93.5816V12.5037H92.8811V15.8177ZM96.4482 12.5037V14.5289L94.8963 12.5037H94.3144V15.8177H95.0149V13.8304L96.5667 15.8177H97.1487V12.5037H96.4482ZM98.582 15.2329V14.4531H100.058V13.8683H98.582V13.1264H100.058V12.5037H97.8869V15.8177H100.058V15.2329H98.582Z" fill="#1ABA20" />
                                            </Link>
                                            <Link className='cursor-none'>
                                                <path d="M135.16 29.8267C143.355 29.8267 149.999 23.1498 149.999 14.9134C149.999 6.67694 143.355 0 135.16 0C126.964 0 120.32 6.67694 120.32 14.9134C120.32 23.1498 126.964 29.8267 135.16 29.8267Z" fill="#BD3A16" />
                                                <path d="M140.284 9.76366C139.67 9.14633 138.851 8.80518 137.978 8.80518C137.105 8.80518 136.286 9.14633 135.672 9.76366L133.856 11.5886C133.759 11.686 133.705 11.816 133.705 11.9568C133.705 12.0976 133.759 12.2276 133.856 12.325C134.061 12.5308 134.389 12.5308 134.589 12.325L136.404 10.5001C137.272 9.62828 138.684 9.62828 139.551 10.5001C140.419 11.372 140.419 12.7907 139.551 13.6626L137.735 15.4875C137.315 15.9099 136.76 16.1427 136.162 16.1427C135.564 16.1427 135.009 15.9099 134.589 15.4875C134.298 15.1951 134.093 14.8323 134.001 14.4315C133.969 14.2961 133.888 14.1824 133.77 14.1066C133.651 14.0362 133.511 14.0146 133.376 14.0471C133.242 14.0795 133.128 14.1608 133.053 14.2799C132.983 14.399 132.956 14.5398 132.994 14.6752C133.134 15.26 133.43 15.7961 133.856 16.2239C134.47 16.8413 135.289 17.1824 136.162 17.1824C137.035 17.1824 137.854 16.8413 138.468 16.2239L140.284 14.399C140.898 13.7817 141.238 12.9586 141.238 12.0813C141.238 11.2041 140.898 10.381 140.284 9.76366Z" fill="white" />
                                                <path d="M135.727 17.5019L133.911 19.3268C133.044 20.1987 131.632 20.1987 130.765 19.3268C129.897 18.455 129.897 17.0362 130.765 16.1644L132.581 14.3395C133.448 13.4676 134.86 13.4676 135.727 14.3395C136.018 14.6319 136.223 14.9947 136.315 15.3954C136.347 15.5308 136.428 15.6445 136.546 15.7203C136.665 15.7907 136.805 15.8178 136.94 15.7799C137.074 15.7474 137.188 15.6662 137.263 15.5471C137.333 15.4279 137.36 15.2871 137.322 15.1518C137.182 14.5669 136.886 14.0308 136.46 13.603C135.846 12.9857 135.027 12.6445 134.154 12.6445C133.281 12.6445 132.462 12.9857 131.848 13.603L130.032 15.4279C129.418 16.0453 129.078 16.8684 129.078 17.7456C129.078 18.6229 129.418 19.446 130.032 20.0633C130.646 20.6806 131.465 21.0218 132.338 21.0218C133.211 21.0218 134.03 20.6806 134.644 20.0633L136.46 18.2384C136.665 18.0326 136.665 17.7023 136.46 17.5019C136.255 17.3016 135.927 17.2962 135.727 17.5019Z" fill="white" />
                                            </Link>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2013_5039">
                                                <rect width={150} height={30} fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    </div>
                    </div>
                </Col>
            </Row>
            <div className='w-100 d-flex justify-content-center align-items-center'>
                <Row className='w-90 mt-5'>
                    <Col xs={12} className='d-flex justify-content-center align-items-center'>
                        <button
                            className="btn-cancle01 me-4"
                            onClick={() => close()}
                        >
                            BACK
                        </button>
                        <button
                            className="btn-save01"
                            onClick={(e) => 
                                save()
                            }
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
    </div>
  )
}

export default PreviewNewsEvent;